var map = {
	"./ion-accordion_2.entry.js": [
		36371,
		8592,
		6371
	],
	"./ion-action-sheet.entry.js": [
		12503,
		8592,
		2503
	],
	"./ion-alert.entry.js": [
		79978,
		8592,
		9978
	],
	"./ion-app_8.entry.js": [
		87469,
		8592,
		9565
	],
	"./ion-avatar_3.entry.js": [
		49597,
		9597
	],
	"./ion-back-button.entry.js": [
		26047,
		8592,
		6047
	],
	"./ion-backdrop.entry.js": [
		97620,
		7487
	],
	"./ion-breadcrumb_2.entry.js": [
		9884,
		8592,
		2462
	],
	"./ion-button_2.entry.js": [
		69658,
		9658
	],
	"./ion-card_5.entry.js": [
		41451,
		1451
	],
	"./ion-checkbox.entry.js": [
		70398,
		398
	],
	"./ion-chip.entry.js": [
		61189,
		1189
	],
	"./ion-col_3.entry.js": [
		71353,
		1353
	],
	"./ion-datetime-button.entry.js": [
		59232,
		6449,
		9232
	],
	"./ion-datetime_3.entry.js": [
		89240,
		6449,
		8592,
		9240
	],
	"./ion-fab_3.entry.js": [
		99408,
		8592,
		9408
	],
	"./ion-img.entry.js": [
		25644,
		5644
	],
	"./ion-infinite-scroll_2.entry.js": [
		18283,
		8592,
		5933
	],
	"./ion-input.entry.js": [
		13546,
		8592,
		3546
	],
	"./ion-item-option_3.entry.js": [
		65311,
		8592,
		2954
	],
	"./ion-item_8.entry.js": [
		2989,
		8592,
		2989
	],
	"./ion-loading.entry.js": [
		93039,
		3039
	],
	"./ion-menu_3.entry.js": [
		72398,
		8592,
		2398
	],
	"./ion-modal.entry.js": [
		60506,
		8592,
		506
	],
	"./ion-nav_2.entry.js": [
		19050,
		8592,
		9050
	],
	"./ion-picker-column-internal.entry.js": [
		5069,
		8592,
		5069
	],
	"./ion-picker-internal.entry.js": [
		33669,
		3669
	],
	"./ion-popover.entry.js": [
		40954,
		8592,
		954
	],
	"./ion-progress-bar.entry.js": [
		43043,
		3043
	],
	"./ion-radio_2.entry.js": [
		489,
		489
	],
	"./ion-range.entry.js": [
		62621,
		8592,
		2621
	],
	"./ion-refresher_2.entry.js": [
		30879,
		8592,
		8534
	],
	"./ion-reorder_2.entry.js": [
		90787,
		8592,
		6321
	],
	"./ion-ripple-effect.entry.js": [
		91001,
		1001
	],
	"./ion-route_4.entry.js": [
		12884,
		2884
	],
	"./ion-searchbar.entry.js": [
		38761,
		8592,
		8761
	],
	"./ion-segment_2.entry.js": [
		73377,
		8592,
		3377
	],
	"./ion-select_3.entry.js": [
		24289,
		4289
	],
	"./ion-slide_2.entry.js": [
		29206,
		9206
	],
	"./ion-spinner.entry.js": [
		34067,
		8592,
		4067
	],
	"./ion-split-pane.entry.js": [
		66043,
		6043
	],
	"./ion-tab-bar_2.entry.js": [
		77963,
		8592,
		7963
	],
	"./ion-tab_2.entry.js": [
		1965,
		8592,
		1965
	],
	"./ion-text.entry.js": [
		67777,
		7777
	],
	"./ion-textarea.entry.js": [
		246,
		246
	],
	"./ion-toast.entry.js": [
		57156,
		7156
	],
	"./ion-toggle.entry.js": [
		47811,
		8592,
		7811
	],
	"./ion-virtual-scroll.entry.js": [
		9738,
		9738
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 50863;
module.exports = webpackAsyncContext;